import { render, staticRenderFns } from "./ReadingCenter.vue?vue&type=template&id=ac08bb2e&"
import script from "./ReadingCenter.vue?vue&type=script&lang=js&"
export * from "./ReadingCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports